"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbodycare = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbodycare` : '') + (description ? ` desc-brandedbodycare` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbodycare"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbodycare"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.9697 48.2821L39.089 18.8312C38.875 17.2091 37.5426 16 35.9572 16H13.0428C11.4672 16 10.125 17.2091 9.91102 18.8312L6.03034 48.2821C5.90391 49.2191 6.17624 50.1663 6.77925 50.8816C7.38226 51.597 8.24787 52 9.16211 52H39.8379C40.7521 52 41.6178 51.5869 42.2208 50.8816C42.8238 50.1663 43.0961 49.2191 42.9697 48.2821Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.4102 0H14.0623C12.0995 0 8.1445 2.07159 1.04907 12.9099C1.02944 12.94 1.01963 12.97 1 13H4.84704C10.7059 4.4234 13.6108 3.2525 14.0623 3.2525H28.4102C29.2934 3.2525 30 2.52194 30 1.63126C30 0.74057 29.2836 0.0100075 28.4102 0.0100075V0Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.7317 10H21.2683C17.8076 10 15 12.6626 15 15.9445V16H34V15.9445C34 12.6626 31.1924 10 27.7317 10Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.9354 3H22V10H28V3H24.9446H24.9354Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 15C3 15 0 20.1442 0 21.875C0 23.6058 1.33846 25 3 25C4.66154 25 6 23.6058 6 21.875C6 20.1442 3 15 3 15Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.76972 50.8993C7.37289 51.6034 8.23873 52 9.15321 52H39.8371C40.7515 52 41.6174 51.5934 42.2205 50.8993C42.8237 50.1953 43.0961 49.2632 42.9696 48.351L39.088 19.3669C39.0685 19.238 39.0393 19.1289 39.0101 19C29.8653 29.8182 18.8137 38.8416 6.40003 45.5745L6.03035 48.351C5.90388 49.2731 6.17627 50.2052 6.77944 50.8993H6.76972Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedbodycare;